// @flow

/* Libs */
import { useEffect, useState } from 'react';
import {
	Link,
	useParams,
	useLocation,
	useHistory
} from 'react-router-dom';

/* Stores */
import useProductsStore from 'Stores/Products';
// import useFurnituresStore from 'Stores/Furnitures';
import useModalStore from 'Stores/Modals';

/* Components */
import Icon from 'Components/Icon';
import BackArrow from 'Components/BackArrow';

const ListProducts = () => {
	// Modal
	const setActiveModal = useModalStore(store => store.setActiveModal);

	// Categories
	const products = useProductsStore(store => store.products);
	const fetchProducts = useProductsStore(store => store.fetchProducts);

	// Current state
	const [filteredProducts, setFilteredProducts] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [displaySearch, setDisplaySearch] = useState(false);

	// params
	const { productid } = useParams();
	const { pathname } = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (productid) {
			setActiveModal('showProduct', { productid });
		}
		if (pathname.includes('/products/new')) {
			setActiveModal('createProduct');
		}
		if (!products) {
			fetchProducts();
		}
	}, []);

	useEffect(() => {
		if (productid) {
			setActiveModal('showProduct', { productid });
		}
	}, [productid]);

	useEffect(() => {
		if (pathname.includes('/products/new')) {
			setActiveModal('createProduct');
		}
	}, [pathname]);

	useEffect(() => {
		if (products) {
			if (searchQuery.length > 0) {
				const filtered = products.filter(product => product.name.trim().toLowerCase().includes(searchQuery));
				setFilteredProducts(filtered);
			} else {
				setFilteredProducts(products);
			}
		}
	}, [searchQuery, products]);

	return (
		<div className="App-Products-listing">
			<div className="products-header">
				<h3><BackArrow to="/inventory/furnitures" />Liste des Produits</h3>
				<div className="products-header-actions">
					<div className="product-create">
						<Icon isHM name="utilitary_plus" onClick={() => history.push('/inventory/products/new')} />
					</div>
					<div className="product-search">
						{ !displaySearch && <Icon isHM name="utilitary_search" onClick={() => setDisplaySearch(true)} /> }
						{ displaySearch && (
							<div className="search-field">
								<input
									type="text"
									onChange={(e) => setSearchQuery(e.target.value)}
									value={searchQuery}
									placeholder="Chercher une fourniture"
								/>
								<Icon
									isHM
									name="utilitary_close"
									onClick={() => {
										setDisplaySearch(false);
										setSearchQuery('');
									}}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="products-list">
				{ !products && <p>Chargement...</p> }
				{ products && products.length === 0 && !searchQuery && <p>Pas de produits enregistrés</p> }
				{ filteredProducts && filteredProducts.length === 0 && searchQuery && <p>Aucun produit trouvé</p> }
				{ filteredProducts && filteredProducts.length > 0 && filteredProducts.map(product => (
					<Link
						to={`/inventory/products/${product.id}`}
						key={product.id}
						className="product-item"
					>
						{ product.name }
					</Link>
				))}
			</div>
		</div>
	);
};

export default ListProducts;
